import { Injectable, Pipe, PipeTransform, inject } from '@angular/core';
import { FormattingService } from '@settings/data-access';

@Pipe({
  name: 'intlCurrency',
  standalone: true,
})
@Injectable({ providedIn: 'root' })
export class IntlCurrencyPipe implements PipeTransform {
  private readonly formattingService = inject(FormattingService);

  /**
   * @param options extra `Intl.NumberFormat` options — e.g. `{ notation: 'compact' }` to
   * abbreviate values that would overflow their container.
   */
  public transform(
    value: string | number,
    locale?: string,
    options?: Intl.NumberFormatOptions
  ): string {
    return this.formattingService.formatCurrency(value, locale, options);
  }
}
